import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { Menu } from "@mui/material";
import { User } from "interfaces/User";
import { useState } from "react";
import TableRow from "ui/Table/TableRow";

type Props = {
  user: User;
  actionsNode: (item: User) => JSX.Element[];
  isOpen: boolean;
  setIsOpen: (val: string) => void;
};

export const UserTableBodyRow = ({
  user,
  actionsNode,
  isOpen,
  setIsOpen,
}: Props) => {
  const { _id, name, email, phoneNumber, containersAmount, isActive } = user;
  const [anchorEl, setAnchorEl] = useState<null | SVGSVGElement>(null);

  const handleClose = () => {
    setAnchorEl(null);
    setIsOpen("");
  };

  const handleClick = (event: React.MouseEvent<SVGSVGElement>) => {
    setAnchorEl(event.currentTarget);
    setIsOpen(_id);
  };

  return (
    <>
      <TableRow key={`user-table-row-${_id}`}>
        <td className="py-2 pl-2">
          <p className="flex justify-center text-faux-gainsboro align-center">
            {name}
          </p>
        </td>
        <td>
          <p className="flex justify-center text-faux-gainsboro align-center">
            {email}
          </p>
        </td>
        <td>
          <p className="flex justify-center text-faux-gainsboro align-center">
            {phoneNumber}
          </p>
        </td>
        <td>
          <p className="flex justify-center text-faux-gainsboro align-center">
            {containersAmount}
          </p>
        </td>
        <td>
          <p className="flex justify-center text-faux-gainsboro align-center">
            {isActive ? "Activo" : "Inactivo"}
          </p>
        </td>
        <td className="pr-16">
          <div className="flex flex-row items-center justify-center gap-2">
            <MoreHorizIcon
              className="cursor-pointer text-faux-cadet hover:text-white"
              fontSize="medium"
              onClick={handleClick}
            />
          </div>
        </td>
        <Menu anchorEl={anchorEl} open={isOpen} onClose={handleClose}>
          {actionsNode(user)}
        </Menu>
      </TableRow>
    </>
  );
};
